export default __webpack_public_path__ + "static/hero-adc2bb623e7e128778f7addb598b4ffc.png";